<template>
  <section class="terms-agreement">
    <section class="terms-contents py-3 container-fluid">
      <v-row justify="center">
        <v-col cols="12" md="11" lg="10">
          <div class="terms-panel">
            <v-card class="terms-card">
              <v-card-title class="terms-title">
                建築計画概要書等Web閲覧システム利用規約
              </v-card-title>

              <!--本文-->
              <v-card-text class="terms-body">
                <div class="terms-html" v-html="termsHtml"></div>
                <v-alert v-if="loadError" dense type="error" class="mt-4 mb-0">
                  利用規約の読み込みに失敗しました。
                </v-alert>

                <!--チェックボックス-->
                <div class="terms-check-group">
                  <v-checkbox
                    v-model="confirmBusinessRule"
                    class="terms-checkbox"
                    hide-details
                    color="#005588"
                    label="本規約の趣旨を逸脱した営利目的の閲覧、目的不明の閲覧、大量閲覧及び建築物を特定しない閲覧を行いません。"
                  />
                  <v-checkbox
                    v-model="confirmAgreement"
                    class="terms-checkbox"
                    hide-details
                    color="#005588"
                    label="上記規約に同意します。"
                  />
                </div>
              </v-card-text>
            </v-card>
            <div class="terms-actions">
              <v-btn
                x-large
                color="#005588"
                dark
                class="terms-submit-button"
                :disabled="!canProceed || loadError"
                @click="agreeAndContinue"
              >
                同意して次へ
              </v-btn>
            </div>
          </div>
        </v-col>
      </v-row>
    </section>
  </section>
</template>

<script>
import { dbglog } from '../common/utils.js'

const TERMS_HTML_URL = '/ges/notices/terms_agreement.html'
const TERMS_AGREED_KEY = 'madogiwa-terms-agreed'

export default {
  data: () => ({
    termsHtml: '',
    loadError: false,
    confirmBusinessRule: false,
    confirmAgreement: false,
  }),
  computed: {
    token () {
      return this.$store.state.token;
    },
    unauthorized () {
      return this.token == undefined || this.token == null || this.token.length == 0;
    },
    authority () {
      return Number(this.$store.state.userInfo?.authority || sessionStorage.getItem('madogiwa-authority') || 0);
    },
    canProceed () {
      return this.confirmBusinessRule && this.confirmAgreement;
    },
  },
  async mounted () {
    this.$store.commit('setCurrentPage', 1);
    this.$store.commit('setMessage', '利用規約をご確認のうえ、同意してください');
    sessionStorage.removeItem(TERMS_AGREED_KEY);

    if (this.unauthorized || this.authority !== 5) {
      this.$router.replace('/');
      return;
    }

    try {
      const response = await fetch(TERMS_HTML_URL);
      this.termsHtml = response.ok ? await response.text() : '';
      this.loadError = !response.ok;
    }
    catch (error) {
      dbglog(`TermsAgreement load failed: ${error}`, -1);
      this.loadError = true;
      this.termsHtml = '';
    }
  },
  methods: {
    agreeAndContinue () {
      if (!this.canProceed || this.loadError) {
        return;
      }

      sessionStorage.setItem(TERMS_AGREED_KEY, 'true');
      this.$router.replace('menu');
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../styles/common/common.css";

.terms-agreement {
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 100%;
  min-height: 0;
  overflow: hidden;
}

.terms-contents {
  display: flex;
  flex: 1 1 auto;
  height: 100%;
  max-height: 100%;
  min-height: 0;
  padding-left: 1rem;
  padding-right: 1rem;
  box-sizing: border-box;
}

.terms-contents :deep(.row) {
  flex: 1 1 auto;
  height: 100%;
  max-height: 100%;
  min-height: 0;
}

.terms-contents :deep(.row > [class*="col-"]) {
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 100%;
  min-height: 0;
}

.terms-panel {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 16px;
  height: 100%;
  max-height: 100%;
  min-height: 0;
  overflow: hidden;
}

.terms-card {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  max-height: 100%;
  min-height: 0;
  overflow: hidden;
  padding-bottom: 16px;
  border: 1px solid #a7b7c4;
  background: linear-gradient(180deg, #f8fbfd 0%, #edf4f8 100%);
}

.terms-title {
  justify-content: center;
  text-align: center;
  color: #15384d;
  font-size: 1.5rem;
  font-weight: 700;
  word-break: keep-all;
}

.terms-body {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 18px;
  color: #183246;
  padding-top: 0;
  padding-bottom: 0;
  padding-left: 4rem;
  padding-right: 4rem;
  max-height: 100%;
  min-height: 0;
  overflow: hidden;
}

.terms-html {
  flex: 1 1 auto;
  min-height: 0;
  max-height: 100%;
  overflow-y: auto;
  padding: 1.25rem 24px;
  border: 1px solid #b9c9d6;
  background: #ffffff;
  line-height: 1.8;
  white-space: normal;
}

.terms-html :deep(h3) {
  margin-top: 0;
  color: #15384d;
}

.terms-html :deep(p) {
  margin-bottom: 1rem;
}

.terms-html :deep(ol),
.terms-html :deep(ul) {
  padding-left: 1.5rem;
}

.terms-check-group {
  display: flex;
  flex-direction: column;
  width: min(100%, 920px);
  margin: 0 auto;
  gap: 4px;
  color: #183246;
  align-items: center;
}

.terms-checkbox {
  width: 100%;
  max-width: 920px;
  font-size: 0.95rem;
  margin: 0 !important;
  padding: 0 !important;
}

.terms-checkbox :deep(.v-input__control) {
  margin: 0 !important;
}

.terms-checkbox :deep(.v-input__slot) {
  margin: 0 !important;
}

.terms-checkbox :deep(.v-label) {
  width: auto;
  justify-content: flex-start;
  text-align: left;
}

.terms-checkbox :deep(.v-messages) {
  min-height: 0 !important;
}

.terms-checkbox :deep(.v-input--selection-controls__input) {
  transform: scale(0.85);
  transform-origin: left center;
}

.terms-actions {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  padding: 0 24px 0;
}

.terms-submit-button {
  flex-direction: column;
  width: 540px;
  font-size: 1.2rem;
}

.terms-submit-button:disabled,
.terms-submit-button.v-btn--disabled,
.terms-submit-button.v-btn--disabled.v-btn--has-bg {
  color: #3f3f3f !important;
  background-color: #bdbdbd !important;
  border-color: #9a9a9a !important;
  box-shadow: none !important;
  opacity: 1 !important;
}

.terms-submit-button:disabled :deep(.v-btn__content),
.terms-submit-button.v-btn--disabled :deep(.v-btn__content) {
  color: #3f3f3f !important;
  opacity: 1 !important;
}
</style>
